import { render, staticRenderFns } from "./RegistriesEdit.vue?vue&type=template&id=5b0befab&"
import script from "./RegistriesEdit.vue?vue&type=script&lang=js&"
export * from "./RegistriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports